import {
    deleteDriverLoading,
    deleteDriverRequest,
    deleteDriverSuccess,
    deleteDriverReject,
    deleteDriverReset
} from "../../actions/driver/delete";

export const deleteDriver = (formData) => async (dispatch, getState) => {
    dispatch(deleteDriverLoading());
    try {
        const { data } = await deleteDriverRequest(getState, formData);
        dispatch(deleteDriverSuccess(data))
    } catch (error) {
        dispatch(deleteDriverReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteDriverReset()) }, 3000);
    }
    return Promise.resolve();
};